import React from "react";
import { AmountFormat } from "components/common/formatter";
import { isEmpty } from "components/common/Utils";
import { useMatterBalances } from "services/matterBalancesService";

const EMPTY_BALANCES = {
  matterRef: "This Matter",
  clientRef: "All Matters",
  matterBalances: {},
  clientBalances: {},
};

const MatterAccount = ({ matterId, clear = false, width = "480px" }) => {
  const { data } = useMatterBalances(clear ? null : matterId);
  const balances = clear ? EMPTY_BALANCES : data ?? EMPTY_BALANCES;

  return (
    <table
      className="balance-table bg-white"
      style={{ maxWidth: width, height: "100%", paddingBottom: "10px" }}
    >
      <thead>
        <tr>
          <th>Balances</th>
          <th></th>
          <th className="text-center">Office Bal</th>
          <th className="text-center">Client Bal</th>
          <th className="text-center">DDA Bal</th>
          <th className="text-center">Unpaid Bills</th>
          <th className="text-center">WIP</th>
          <th className="text-center">U/T</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="fs-sm fw-semibold" style={{ minWidth: "80px" }}>
            {/*{isEmpty(balances.matterRef) ? "Matter" : balances.matterRef}*/}
            {"This Matter"}
          </td>
          <td></td>
          <AmountTD value={balances.matterBalances?.officeBalance} />
          <AmountTD value={balances.matterBalances?.clientBalance} />
          <AmountTD value={balances.matterBalances?.ddaBalance} />
          <AmountTD value={balances.matterBalances?.unpaidBills} />
          <AmountTD value={balances.matterBalances?.wipBalance} />
          <AmountTD value={balances.matterBalances?.undertakingBalance} />
        </tr>
        <tr>
          <td className="fs-sm fw-semibold">{"All Matters"}</td>
          <td></td>
          <AmountTD value={balances.clientBalances?.officeBalance} />
          <AmountTD value={balances.clientBalances?.clientBalance} />
          <AmountTD value={balances.clientBalances?.ddaBalance} />
          <AmountTD value={balances.clientBalances?.unpaidBills} />
          <AmountTD value={balances.clientBalances?.wipBalance} />
          <AmountTD value={balances.clientBalances?.undertakingBalance} />
        </tr>
      </tbody>
    </table>
  );
};

export default MatterAccount;

const AmountTD = ({ value }) => (
  <td
    className="text-center pe-1"
    style={{ width: "90px", whiteSpace: "nowrap" }}
  >
    {AmountFormat(value)}
  </td>
);
